import React from 'react';

import { IconProps, StyledPath, StyledSvg } from '../iconCommons';

export const IconDeleteLine = ({ color = 'currentColor', size = 'xSmall', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 14" size={size} {...props}>
        <StyledPath
            stroke={color}
            color="none"
            d="M1 3.4h10.8m-1.2 0v8.4A1.2 1.2 0 019.4 13h-6a1.2 1.2 0 01-1.2-1.2V3.4m1.8 0V2.2A1.2 1.2 0 015.2 1h2.4a1.2 1.2 0 011.2 1.2v1.2"
        />
    </StyledSvg>
);
